import { useState, useEffect } from 'react';

import API from 'services/api';

const useBumpPrice = categoryId => {
  const [bumpPrice, setBumpPrice] = useState(0);
  useEffect(() => {
    if (categoryId) {
      (async () => {
        try {
          const { data } = await API.getPricesInventory(categoryId);

          const price = data?.prices?.find(
            product => product.product_name === 'credit_1',
          );

          setBumpPrice(price.price || 0);
        } catch (e) {
          console.error(e);
        }
      })();
    }
  }, [categoryId]);
  return bumpPrice;
};

export default useBumpPrice;
